import ActionTypes from './ActionTypes';

export const setMap = (map) => {
    return {
        type : ActionTypes.SET_MAP,
        payload : map
    }
}

export const menuToggle = (menu) => {
    return {
        type : ActionTypes.MENU_TOGGLE,
        payload : menu
    }
}

export const setMapStyle = (style) => {
    return {
        type : ActionTypes.MAP_STYLE,
        payload : style
    }
}

export const searchLocation = (location) => {
    return {
        type : ActionTypes.SEARCH,
        payload : location
    }
}

export const filterMap = (data) => {
    return {
        type : ActionTypes.SET_FILTER,
        payload : data
    }
}

export const setCategory = (category) => {
    return {
        type : ActionTypes.SET_CATEGORY,
        payload : category
    }
}

export const setActiveFilter = (filter) => {
    return {
        type : ActionTypes.SET_ACTIVE_FILTER,
        payload : filter
    }
}


export const setMapLoaded = (loaded) => {
    return {
        type : ActionTypes.MAP_LOADED,
        payload : loaded
    }
}


export const setDirection = (direction) => {
    return {
        type : ActionTypes.MAP_DIRECTION,
        payload : direction
    }
}

export const placesList = (places) => {
    return {
        type : ActionTypes.LOCATION_LIST,
        payload : places
    }
}




// WEBPACK FOOTER //
// ./src/actions/index.js